/* unplugin-vue-components disabled */import { render } from "./bottomFoot.vue?vue&type=template&id=4b262bde&scoped=true"
import script from "./bottomFoot.vue?vue&type=script&lang=js"
export * from "./bottomFoot.vue?vue&type=script&lang=js"

import "./bottomFoot.vue?vue&type=style&index=0&id=4b262bde&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b262bde"]])

export default __exports__